export const createWebsiteChannel = _ref => {
  let {
    clientSdk,
    applicationId
  } = _ref;
  return {
    invoke: async _ref2 => {
      let {
        namespace,
        method,
        args
      } = _ref2;
      if (!clientSdk) {
        throw new Error('Wix Site SDK only works in a Wix site environment. Learn more: https://dev.wix.com/docs/sdk/host-modules/site/introduction');
      }
      return clientSdk.invoke({
        namespace,
        method,
        args,
        applicationId,
        accessToken: 'accessToken'
      });
    },
    getAccessToken: () => {
      throw new Error('Not implemented');
    },
    observeState: () => ({
      disconnect: () => {}
    })
  };
};
//# sourceMappingURL=channel.js.map